exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-form-1{padding:5%;box-shadow:0 5px 8px 0 rgba(0,0,0,.2),0 9px 26px 0 rgba(0,0,0,.19)}.login-form-1 h3{text-align:center;color:#333}.login-form-1 .btnSubmit{font-weight:600;color:#fff;background-color:#0062cc}.submit-error{color:red;font-size:20px}.login-logo{max-width:300px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-02ba30a5","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/auth/Login.vue
// module id = 1010
// module chunks = 0